import React from "react";
import ExternalAgentDashboard from "./externalAgent/externalAgentDashbord.tsx";
import DashboardAdmin from "./admin/dashbordAdmin.tsx";
import MainCategoryDashbord from "./mainCategory/mainCategoryDashbord.tsx";
import { useAppSelector } from "@core/store/hook.ts";
import { userConnected } from "@core/slice/UsersSlice.ts";
import { TypeProfil } from "@modules/plaintes/plaintes.model.ts";

const Dashboard: React.FC = () => {
  const detailsUserConnected = useAppSelector(userConnected);

    const isExternalAgent = detailsUserConnected && detailsUserConnected.profil.type === TypeProfil.EXTERNAL;
    const isAdmin = detailsUserConnected && detailsUserConnected.profil.type === TypeProfil.ADMIN;
    const isInternalAgent = detailsUserConnected && detailsUserConnected.profil.type === TypeProfil.INTERNAL;
    const rgs = detailsUserConnected && detailsUserConnected.profil.type === TypeProfil.RGS
    const cgp = detailsUserConnected && detailsUserConnected.profil.type === TypeProfil.CGP;
    const pfm = detailsUserConnected && detailsUserConnected.profil.type === TypeProfil.PFM;
    const drps =detailsUserConnected && detailsUserConnected.profil.type === TypeProfil.ADMIN_DRPS;
    const admin_psrc = detailsUserConnected && detailsUserConnected.profil.type === TypeProfil.ADMIN_PSRC;
    const dgrsu = detailsUserConnected && detailsUserConnected.profil.type === TypeProfil.DGRSU;
    const communication = detailsUserConnected && detailsUserConnected.profil.type === TypeProfil.COMMUNICATION;
    
    // const competent_entity = detailsUserConnected && detailsUserConnected.profil.type === TypeProfil.COMPETENT_ENTITY;
    // IL N'Y A PAS ENCORE DE DASHBOARD POUR LE COMPETENT_ENTITY POUR LE MOMENT
    

  return (
    <>
      {isExternalAgent && <ExternalAgentDashboard />}
      {(isAdmin || rgs || cgp || pfm || drps || dgrsu || communication) && <DashboardAdmin />}
      {(isInternalAgent || admin_psrc) && <MainCategoryDashbord />}
    </>
  );
};

export default Dashboard;
